@import '../../style/index';

:host {
  display: block;
  margin-top: var(--spacings-l);

  rcm-headline {
    margin-bottom: var(--spacings-s);

    @include xlarge-up {
      margin-bottom: var(--spacings-l);
    }
  }

  .content-navigation {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0 var(--spacings-l);

    rcm-button {
      flex: 0 0 100%;
      // negative margin to make rcm-button padding space smaller
      margin: rem-calc(-7px) 0;

      --button-line-height: rem-calc(26px);
      --button--underline-icon-height: unset;

      @include medium-up {
        flex: 0 0 auto;
      }
    }
  }

  .fixed-header {
    display: none;
    padding: var(--spacings-s) 0;
  }

  .is-pinned {
    display: none;
    position: fixed;
    width: 100%;
    box-shadow: 0 2px 12px #0000001a;
    background-color: var(--colors-basic-white);
    padding-top: rem-calc(5px);
    z-index: 299;

    @include xlarge-up() {
      display: block !important;
      top: 150px;
    }
  }
}
